export const GET_TRANSLATIONS_REQUEST = 'GET_TRANSLATIONS_REQUEST';
export const GET_TRANSLATIONS_SUCCESS = "GET_TRANSLATIONS_SUCCESS";
export const GET_LANGUAGES_SUCCESS = 'GET_LANGUAGES_SUCCESS';
export const LANGUAGE_SUCCESS = 'LANGUAGE_SUCCESS';
export const SET_LANGUAGES_REQUEST = 'SET_LANGUAGES_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const LOG_OUT = 'LOG_OUT';
export const SET_IS_SHOW_LOGIN_MODAL = 'SET_IS_SHOW_LOGIN_MODAL';
export const ADD_SPINNER = 'ADD_SPINNER';
export const REMOVE_SPINNER = 'REMOVE_SPINNER';